import { filled } from './model';
import { Band, SectionIndex } from './ui';

export default function AchievementsSection({
  achievements,
  index,
}: {
  achievements: string[];
  index: string;
}) {
  const items = filled(achievements);
  if (!items.length) return null;

  return (
    <Band id="achievements">
      <SectionIndex index={index} title="Achievements" />
      <ul className="grid gap-3 md:grid-cols-2">
        {items.map((item, i) => (
          <li key={`${item}-${i}`} className="panel p-4 text-sm leading-relaxed text-muted md:text-base">
            {item}
          </li>
        ))}
      </ul>
    </Band>
  );
}
